import { ProfileDto } from '@diritto/common/account/dtos/profile.dto';
import { Color } from '@diritto/common/style/color';
import { FontWeight } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { PartnerProfileMenuItem } from 'app-components/accounts/partners/menu/PartnerProfileMenuItem';
import { ProfileMenuItem } from 'app-components/accounts/profiles/menu/ProfileMenuItem';
import { useAuthState } from 'contexts/AuthProvider';
import { PartnerIcon } from 'icons/PartnerIcon';
import Link from 'next/link';
import { useGetInboxProfileNotiUnreadCountQuery } from 'queries/noti/useGetInboxProfileNotiUnreadCountQuery';
import { useGetMyProfilesQuery } from 'queries/profile/useGetMyProfilesQuery';
import { useCallback } from 'react';

type PartnerMenuProps = {
  onBlur?: () => void;
  onProfileChanged?: (profile: ProfileDto) => void;
};

export function PartnerMenu({ onBlur, onProfileChanged }: PartnerMenuProps) {
  const { changeProfile, partner } = useAuthState();
  const { data: profileData } = useGetMyProfilesQuery();
  const { data: inboxUnreadCountData } = useGetInboxProfileNotiUnreadCountQuery();

  const handleProfileAvatarClick = useCallback(
    async (target: ProfileDto) => {
      onBlur?.();
      await changeProfile(target.id);
      onProfileChanged?.(target);
    },
    [changeProfile, onBlur, onProfileChanged],
  );

  return (
    <>
      {profileData?.profiles.map(p => (
        <ProfileMenuItem
          key={p.id}
          onClick={() => handleProfileAvatarClick(p)}
          nickname={p.nickname}
          size={24}
          file={p.profileImage}
          inboxCount={inboxUnreadCountData?.inboxProfileUnreadCount[p.id] || 0}
        />
      ))}
      <StyledDivider />
      <StyledCpProfileTitle>파트너 프로필</StyledCpProfileTitle>
      <Link href={`/accounts/partners/${partner?.id}`}>
        <StyledProfileMenuItem nickname={partner?.name} file={partner?.profileImage} fontWeight={FontWeight.Bold}>
          {partner?.verifiedAt && <PartnerIcon />}
        </StyledProfileMenuItem>
      </Link>
      <StyledDivider />
    </>
  );
}

const StyledProfileMenuItem = styled(PartnerProfileMenuItem)`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledDivider = styled.div`
  height: 1px;
  background-color: ${Color.Gray200};
  flex: none;
  order: 1;
  flex-grow: 0;
`;

const StyledCpProfileTitle = styled.div`
  padding: 14px 16px 13px 16px;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px; /* 150% */
`;
